<template>
    <div>
        <!-- Mobile -->
        <Mobile
            v-if="$vuetify.breakpoint.mobile"
        />

        <!-- Pc -->
        <Pc
            v-if="!$vuetify.breakpoint.mobile"
        />
    </div>
</template>
<script>
import Mobile from './Footer/Mobile'
import Pc from './Footer/Pc'

export default {
    components: {
        Mobile,
        Pc
    }
}
</script>